var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"on-transaction-label",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._t("label-text"),_vm._v(" "),_c('div',{staticClass:"what-to-do"},[_vm._v("מה כדאי לעשות?")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }